import { render } from "./praFileDialog.vue?vue&type=template&id=345d149a&scoped=true"
import script from "./praFileDialog.vue?vue&type=script&lang=js"
export * from "./praFileDialog.vue?vue&type=script&lang=js"

import "./praFileDialog.vue?vue&type=style&index=0&id=345d149a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345d149a"]])

export default __exports__